import { render, staticRenderFns } from "./UnitMaster.vue?vue&type=template&id=493faf84&scoped=true"
import script from "./UnitMaster.vue?vue&type=script&lang=js"
export * from "./UnitMaster.vue?vue&type=script&lang=js"
import style0 from "./UnitMaster.vue?vue&type=style&index=0&id=493faf84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493faf84",
  null
  
)

export default component.exports